import styled from 'styled-components';

const BaseSvgWrapper = styled.span`
  display: flex;

  svg {
    width: 28px;
    height: 28px;
  }
`;

export default BaseSvgWrapper;
